// pages/login.page.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './../services/auth.service';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logoFiskaGroup from './../assets/images/logos/fiskagroup.png';

function LoginPage() {
    const [email, setEmail] = useState('pierre@fiskagroup.com');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();

    // where to go after login (set in PrivateRoute)
    const from = location.state?.from?.pathname || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const res = await login({ email, password });
        setSubmitting(false);

        if (res?.ok) {
            // go back to the originally-requested route
            navigate(from, { replace: true });
        }
    };

    return (
        <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
            <img src={logoFiskaGroup} alt="Logo Fiska\\Group" className="mb-8 w-96" />
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center">Connexion</h2>

                <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700 mb-2">E-mail :</label>
                    <input
                        type="email"
                        id="email"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                </div>

                <div className="mb-4 relative">
                    <label htmlFor="password" className="block text-gray-700 mb-2">Mot de passe :</label>
                    <input
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword((s) => !s)}
                        className="absolute bottom-3 right-3 text-gray-600"
                        aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                    >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                </div>

                <button
                    type="submit"
                    disabled={submitting}
                    className={`w-full bg-primary text-white py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${submitting ? 'opacity-60 cursor-not-allowed' : 'hover:bg-primary-dark'}`}
                >
                    {submitting ? 'Connexion…' : 'Se connecter'}
                </button>
            </form>
        </div>
    );
}

export default LoginPage;